import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  StateService,
  ToolService,
  RouterService,
  AbsenceEntry,
  AbsenceEntryRequest,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-absence-form',
  templateUrl: './absence-form.component.html',
  styleUrls: ['./absence-form.component.scss'],
  standalone: false,
})
export class AbsenceFormComponent implements OnInit {
  constructor(
    public state: StateService,
    public tools: ToolService,
    public routerService: RouterService,
    public modalCtrl: ModalController
  ) {}

  private subs: Subscription[] = [];
  public absenceEntryId: string;
  public absenceEntryRequest: AbsenceEntryRequest = {};
  public absenceEntry: AbsenceEntry = {};
  private allAbsenceEntries: AbsenceEntry[] = [];
  public typeOptions: string[] = [
    'Urlaub',
    'Krank',
    'Schlechtwetter',
    'Schule',
  ];
  public selectedUsers: string[] = [];
  public timeError: boolean;
  public userError: boolean = true;
  public singleCollisionError: boolean = false;
  public collisionErrorList: string[] = [];
  public dayCount: number = 1;
  public showWeekendInfo: boolean = false;

  ngOnInit() {
    if (this.absenceEntryId != null) {
      this.subs.push(
        this.state.absenceEntries$.subscribe((x) => {
          this.allAbsenceEntries = x;
          this.absenceEntry = JSON.parse(
            JSON.stringify(x.find((y) => y.id == this.absenceEntryId))
          );
          this.userError = false;
          this.selectedUsers = [this.absenceEntry.user];
        })
      );
    } else {
      this.subs.push(
        this.state.absenceEntries$.subscribe((x) => {
          this.allAbsenceEntries = x;
        })
      );
      this.initNewAbsenceEntry();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => {
      x.unsubscribe();
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  initNewAbsenceEntry() {
    this.absenceEntryRequest.type = 'Urlaub';
    this.absenceEntryRequest.timeEntry = {};
    if (!this.state.userHasMinType(1)) {
      this.absenceEntryRequest.users = [this.state.userName.toLowerCase()];
      this.userError = false;
    } else {
      if (this.selectedUsers.length > 0) {
        this.absenceEntryRequest.users = this.selectedUsers;
        this.userError = false;
      }
    }
  }

  userChange(e: any) {
    if (this.absenceEntryId == null) {
      this.absenceEntryRequest.users = e;
    } else {
      this.absenceEntry.user = e;
    }
    this.userError = e.length == 0;
    this.checkCollisionError();
  }

  async createTimeEntry() {
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.sendAbsenceEntryRequest(this.absenceEntryRequest);
  }

  async updateTimeEntry() {
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.updateAbsenceEntry(this.absenceEntry);
  }

  dateChanged(evt: string) {
    this.absenceEntry.date = evt;
    this.checkTimeErrors();
    this.checkCollisionError();
    this.dayCount = 1;
    this.showWeekendInfo = this.tools.hasWeekend(evt);
  }

  startDateChanged(evt: string) {
    this.absenceEntryRequest.timeEntry.start = evt;
    this.checkTimeErrors();
    this.checkCollisionError();
    this.dayCount = this.tools.calculateDays(
      this.absenceEntryRequest.timeEntry.start,
      this.absenceEntryRequest.timeEntry.end
    );
    this.showWeekendInfo = this.tools.hasWeekend(
      this.absenceEntryRequest.timeEntry.start,
      this.absenceEntryRequest.timeEntry.end
    );
  }
  endDateChanged(evt: string) {
    this.absenceEntryRequest.timeEntry.end = evt;
    this.checkTimeErrors();
    this.checkCollisionError();
    this.dayCount = this.tools.calculateDays(
      this.absenceEntryRequest.timeEntry.start,
      this.absenceEntryRequest.timeEntry.end
    );
    this.showWeekendInfo = this.tools.hasWeekend(
      this.absenceEntryRequest.timeEntry.start,
      this.absenceEntryRequest.timeEntry.end
    );
  }

  private checkTimeErrors() {
    if (this.absenceEntryId) {
    } else {
      if (
        this.absenceEntryRequest.timeEntry.start >
        this.absenceEntryRequest.timeEntry.end
      ) {
        this.timeError = true;
      } else {
        this.timeError = false;
      }
    }
  }

  private checkCollisionError() {
    this.singleCollisionError = false;
    this.collisionErrorList = [];
    this.allAbsenceEntries
      .filter(
        (x) => x.user == this.absenceEntry.user && x.id != this.absenceEntry.id
      )
      ?.forEach((y) => {
        if (this.tools.dateStringsAreSameDay(y.date, this.absenceEntry.date)) {
          this.singleCollisionError = true;
        }
      });

    this.tools
      .getDatesBetween(
        this.absenceEntryRequest.timeEntry.start,
        this.absenceEntryRequest.timeEntry.end
      )
      .forEach((date) => {
        this.absenceEntryRequest.users?.forEach((user) => {
          this.allAbsenceEntries
            .filter((entry) => entry.user == user)
            .forEach((x) => {
              if (this.tools.dateStringsAreSameDay(x.date, date)) {
                this.collisionErrorList.push(
                  this.state.getUserDisplayName(user) +
                    ': ' +
                    this.tools.formatDt(x.date) +
                    ' exisitert bereits'
                );
              }
            });
        });
      });
  }
}
